import {
  SvgCalendar,
  SvgFileUp,
  SvgHourglass,
  SvgMapPin,
  MediaIcon,
  ChartIcon,
  DiscountIcon,
  UserIcon,
  UsersIcon,
  PackageIcon,
  MonitorIcon,
} from "./components/icons";

const SUPER_TABS = [
  {
    path: "customers",
    titleKey: "super.customers",
    icon: UserIcon,
    hasCreate: false,
    hasArchive: false,
    hasSearch: true,
  },
  {
    path: "employees",
    titleKey: "super.employees",
    icon: UsersIcon,
    hasCreate: true,
    hasArchive: true,
    hasSearch: false,
  },
  {
    path: "packages",
    titleKey: "super.packages",
    icon: PackageIcon,
    hasCreate: true,
    hasArchive: true,
    hasSearch: false,
  },
  {
    path: "locations",
    titleKey: "super.locations",
    icon: SvgMapPin,
    hasCreate: true,
    hasArchive: true,
    hasSearch: false,
  },
  {
    path: "services",
    titleKey: "super.services",
    icon: SvgHourglass,
    hasCreate: true,
    hasArchive: true,
    hasSearch: false,
  },
  {
    path: "allowed-paper-wallets",
    titleKey: "super.import",
    icon: SvgFileUp,
    hasCreate: true,
    hasArchive: false,
    hasSearch: false,
  },
  {
    path: "holidays",
    titleKey: "super.calendar",
    icon: SvgCalendar,
    hasCreate: true,
    hasArchive: false,
    hasSearch: false,
  },
  {
    path: "media-content",
    titleKey: "super.media",
    icon: MediaIcon,
    hasCreate: true,
    hasArchive: false,
    hasSearch: false,
  },
  {
    path: "flexible-discount",
    titleKey: "super.discounts",
    icon: DiscountIcon,
    hasCreate: true,
    hasArchive: true,
    hasSearch: false,
  },
  {
    path: "marketing",
    titleKey: "super.marketing",
    icon: ChartIcon,
    hasCreate: false,
    hasArchive: false,
    hasSearch: false,
  },
  {
    path: "computers",
    titleKey: "super.playtime",
    icon: MonitorIcon,
    hasCreate: false,
    hasArchive: false,
    hasSearch: false,
  },
];

export default SUPER_TABS;
